import type { CityConfig } from "../city-template/types";

export const louisvilleCoConfig: CityConfig = {
  city: "Louisville",
  state: "Colorado",
  stateAbbr: "CO",
  slug: "louisville-co",
  route: "/louisville-co",
  title: "Emergency Passport Louisville, CO — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Louisville, Colorado — as fast as 24 hours. Same-day courier processing for Louisville, Lafayette, Superior, Broomfield, and all Boulder County travelers. A+ BBB rated, registered State Dept. courier. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Louisville, CO",
  heroSubtitle: "Tech conference in Europe and your passport just expired? Family reunion abroad and you realized the kids' passports are out of date? We help Louisville residents — from historic Old Town families to tech corridor professionals to Coal Creek neighborhood homeowners — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates typically 30–100% lower than other passport courier resellers. As fast as 24 hours. A+ BBB rated.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Louisville%20Colorado%20historic%20Main%20Street%20with%20charming%20brick%20storefronts%20and%20tree%20lined%20sidewalks%2C%20the%20Rocky%20Mountain%20Front%20Range%20foothills%20in%20the%20background%2C%20a%20vibrant%20small%20town%20downtown%20with%20boutique%20shops%20and%20restaurants%2C%20the%20Coal%20Creek%20Trail%20with%20green%20open%20space%2C%20golden%20hour%20light%20bathing%20the%20historic%20buildings%20in%20warm%20tones%2C%20professional%20photography%2C%20no%20visible%20text%20or%20people%2C%20clean%20wide%20angle%20view%20capturing%20authentic%20Colorado%20small%20town%20beauty&width=1800&height=700&seq=louisville-co-hero-001&orientation=landscape",
  heroImageAlt: "Louisville Colorado historic Main Street with charming downtown and Front Range mountain backdrop",
  geoPosition: "39.9778;-105.1319",
  geoPlacename: "Louisville, Colorado",
  lastModified: "2026-06-05",
  regionalAgency: {
    name: "Colorado Passport Agency",
    address: "7245 S Havana Street Suite B-600, Centennial, CO 80112",
    distance: "Approximately 30 miles southeast via US-36 and I-225 — about 40 minutes",
  },
  nearbyCitiesZips: [
    { name: "Louisville", zips: "80027" },
    { name: "Lafayette", zips: "80026" },
    { name: "Superior", zips: "80027" },
    { name: "Broomfield", zips: "80020, 80021, 80023, 80038" },
    { name: "Boulder", zips: "80301, 80302, 80303, 80304, 80305" },
    { name: "Erie", zips: "80514, 80516" },
    { name: "Longmont", zips: "80501, 80502, 80503, 80504" },
    { name: "Westminster", zips: "80020, 80021, 80023, 80030, 80031" },
    { name: "Arvada", zips: "80001, 80002, 80003, 80004, 80005, 80007" },
    { name: "Gunbarrel", zips: "80301" },
    { name: "Niwot", zips: "80503, 80544" },
    { name: "Thornton", zips: "80229, 80233, 80241, 80260, 80602" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier service for urgent Boulder County departures and tech corridor business travel" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved — just 30 miles to the Colorado Passport Agency" },
    { icon: "ri-computer-line", title: "Tech Corridor Service", desc: "Specialized help for Louisville's tech professionals with international business travel" },
    { icon: "ri-mail-send-line", title: "Overnight Shipping", desc: "Prepaid labels from any UPS or FedEx in Louisville, Lafayette, or Boulder" },
  ],
  internalLinks: [
    { name: "Expedited passport in Boulder, CO", route: "/boulder" },
    { name: "Emergency passport help in Broomfield, CO", route: "/broomfield" },
    { name: "Fast passport renewal in Lafayette area", route: "/lafayette-co" },
    { name: "Urgent passport services for Erie and Superior", route: "/erie-co" },
    { name: "Colorado passport services overview", route: "/colorado" },
    { name: "Passport courier services in Longmont", route: "/longmont" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Louisville remotely via secure registered courier. Our couriers hand-deliver your documents directly to U.S. Department of State processing facilities. Louisville's location — 30 miles from the Colorado Passport Agency — makes our courier service especially valuable. Skip the drive down US-36 and let us handle everything.",
  fpcOfficeAddress: "7245 S Havana Street Suite B-600, Centennial, CO 80112",
  fpcOfficeDistance: "Serving all of Louisville, Lafayette, Superior, and Boulder County",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Louisville and the surrounding Boulder County communities. From historic Old Town and Main Street to the Coal Creek and Centennial neighborhoods, from the technology corridor along US-36 to the residential areas near Harper Lake — we serve every corner of Louisville and its surroundings.",
  nearbyCitiesIntro: "We serve Louisville and all nearby Boulder County communities including Lafayette, Superior, Broomfield, Boulder, Erie, Longmont, Gunbarrel, and Niwot. We also serve Westminster, Arvada, and Thornton in the north metro area.",
  howItWorksIntro: "Most Louisville travelers complete everything online and ship documents via overnight courier. Our registered couriers handle the State Department delivery — no need to drive 30 miles to Denver on US-36.",
  mistakesIntro: "Louisville is consistently ranked among the best places to live in America, attracting tech professionals and families who travel internationally. Here are the most common passport mistakes we see from Louisville-area travelers.",
  testimonialsIntro: "Louisville travelers — from Old Town families to US-36 tech corridor professionals to Coal Creek neighborhood residents — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Louisville, CO? Here are the most common ones we hear from Boulder County travelers.",
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates (CDPHE)", url: "https://cdphe.colorado.gov/vital-records", desc: "Colorado Department of Public Health & Environment for vital records statewide" },
    { label: "Marriage Licenses (Boulder County Clerk)", url: "https://www.bouldercounty.gov/", desc: "Boulder County Clerk & Recorder for Louisville area" },
    { label: "Divorce Decrees (Boulder County District Court)", url: "https://www.courts.state.co.us/Courts/District/Index.cfm?District_ID=20", desc: "Boulder County District Court for divorce decree records" },
    { label: "VitalChek Online Ordering", url: "https://www.vitalchek.com/", desc: "Order Colorado vital records online via VitalChek" },
  ],
  statePageRoute: "/states/colorado",
  statePageName: "Colorado",
  dmvWebsite: "https://dmv.colorado.gov",
  dmvLabel: "Colorado DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Drive to Denver (40 min via US-36/I-225)", "Subject to availability — no guarantees"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "No Denver drive required — ship from Louisville", "Perfect for tech corridor business travel and family vacations", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Faster than self-service", "Good for planned seasonal travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Louisville travelers with immediate departure needs — as fast as 24 hours. Our couriers provide the fastest passport service in Boulder County.",
      bullets: ["24–48 hour turnaround available", "Tech corridor business travel expertise", "Boulder County and DIA departure support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Louisville adults with a passport issued within the last 15 years. Skip the post office and let our couriers handle everything.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Louisville or Boulder County address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Louisville residents — from young tech professionals to families with first-time young travelers.",
      bullets: ["Acceptance facility scheduling in Louisville or Boulder", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Louisville residents who lost their passport before international travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Louisville's many families traveling internationally with kids.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Louisville and Boulder County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Louisville CO", description: "Urgent passport processing for Louisville Colorado travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Louisville CO", description: "Fast passport renewal for Louisville Colorado residents with a previously-issued passport." },
    { name: "First-Time Passport Louisville CO", description: "New passport application services for Louisville Colorado residents applying for their first passport." },
    { name: "Child Passport Louisville CO", description: "Minor passport services for Louisville Colorado families with children under 16." },
  ],
  testimonials: [
    {
      name: "Ryan P.",
      location: "Louisville, CO — Old Town",
      rating: 5,
      text: "Tech startup acquired and I needed to be in London for integration meetings within 7 days. My passport was expired. Fast Passport Center renewed it in 2 days. Shipped from the UPS Store on South Boulder Road during my lunch break.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Megan H.",
      location: "Louisville, CO — Coal Creek",
      rating: 5,
      text: "Family trip to Japan for spring break. Five passports — two adult renewals and three first-time for the kids. Fast Passport Center handled everything in 5 business days. The family bundle saved us hundreds.",
      service: "Family Passport Bundle",
    },
    {
      name: "David S.",
      location: "Superior, CO — near Louisville",
      rating: 5,
      text: "Business trip to Singapore with 4 days notice. My passport was valid but I needed additional visa pages. Fast Passport Center got me a new passport in 2 days. Landed in Singapore with a fresh passport.",
      service: "Expedited Passport Renewal",
    },
    {
      name: "Christine M.",
      location: "Louisville, CO — Centennial",
      rating: 5,
      text: "Lost my passport during a move from Boulder to Louisville. Had a trip to Italy booked for the following week. Fast Passport Center replaced it in 48 hours. The document review caught a minor issue that saved me from rejection.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "louisville-co-1",
      name: "Louisville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "300 W Pine St",
      city: "Louisville",
      state: "CO",
      zip: "80027",
      phone: "(303) 666-4271",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Historic downtown Louisville, near Main Street",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Louisville acceptance facility in charming historic downtown. Appointments required — book 1–2 weeks in advance. Convenient for Old Town and Coal Creek residents.",
      icon: "ri-mail-line",
    },
    {
      id: "louisville-co-2",
      name: "Lafayette Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "603 S Public Rd",
      city: "Lafayette",
      state: "CO",
      zip: "80026",
      phone: "(303) 665-0640",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Lafayette, approximately 3 miles northeast of Louisville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Lafayette and east Louisville residents. Good alternative when Louisville appointments are full.",
      icon: "ri-mail-line",
    },
    {
      id: "louisville-co-3",
      name: "Superior Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1600 Coalton Rd",
      city: "Superior",
      state: "CO",
      zip: "80027",
      phone: "(303) 494-2531",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Superior, approximately 3 miles south of Louisville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Superior and south Louisville residents. Modern facility with ample parking. Less crowded than downtown Louisville.",
      icon: "ri-mail-line",
    },
    {
      id: "louisville-co-4",
      name: "Broomfield Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "3001 W 124th Ave",
      city: "Broomfield",
      state: "CO",
      zip: "80020",
      phone: "(303) 469-0719",
      hours: "Mon–Fri: 9:00 AM – 5:00 PM",
      distance: "Broomfield, approximately 8 miles southeast of Louisville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Largest nearby facility with extended evening hours. Good for after-work appointments. Serves Broomfield and east Louisville.",
      icon: "ri-mail-line",
    },
    {
      id: "louisville-co-5",
      name: "Boulder County Clerk — Boulder",
      type: "County Clerk Passport Acceptance",
      address: "1750 33rd St",
      city: "Boulder",
      state: "CO",
      zip: "80301",
      phone: "(303) 413-7717",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Boulder, approximately 10 miles west of Louisville",
      website: "https://www.bouldercounty.gov/",
      websiteLabel: "Boulder County Clerk",
      notes: "Boulder County clerk passport acceptance with early morning hours. Ideal for Louisville residents who work in Boulder and want a pre-work appointment.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 40 min drive to Denver via US-36/I-225", fpc: "No — ship from Louisville" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "US-36 Commute", agency: "Heavy rush hour — unpredictable timing", fpc: "No driving needed — courier handles it" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Louisville's tech professionals often assume expedited service can be started 2 days before a business trip. While 24–48 hour processing is available, starting with more buffer is always better. Plan at least 2 weeks ahead.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo Specifications",
      description: "Louisville photo services sometimes produce photos with slight shadows or off-white backgrounds. Passport photos must have pure white backgrounds with absolutely no shadows. Always verify before submitting.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Waiting for Louisville Post Office Appointments",
      description: "The historic downtown Louisville Post Office is popular and appointments fill quickly, especially during summer and holiday seasons. Book 2 weeks ahead or use Superior or Broomfield as alternatives.",
    },
    {
      icon: "ri-computer-line",
      title: "Business Visa Oversight",
      description: "Louisville's tech corridor companies frequently send employees to countries requiring both a passport AND a business visa. A passport alone isn't sufficient. Verify visa requirements before booking international travel.",
    },
    {
      icon: "ri-global-line",
      title: "Not Checking Passport Validity Requirements",
      description: "Many countries require 6 months of passport validity beyond your stay. Louisville travelers to Europe for tech conferences often discover this requirement days before their flight.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent for Minors",
      description: "For child passports, both parents must appear with ID at the acceptance facility. Louisville families sometimes arrive with only one parent and get turned away. Plan accordingly or arrange notarized consent.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from your home in Louisville or office on the US-36 corridor." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx in Louisville, Lafayette, or Boulder." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — catching errors the post office would miss." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to State Department facilities — no US-36 drive to Denver required." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Louisville address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Louisville, CO?", a: "Fast Passport Center offers emergency passport processing in Louisville, Colorado in as little as 24–48 hours. Our registered couriers hand-deliver your documents to U.S. Department of State facilities — no need to make the 30-mile drive on US-36 to the Colorado Passport Agency." },
    { q: "Does Louisville, CO have its own passport agency?", a: "No — Louisville does not have a regional passport agency. The nearest is the Colorado Passport Agency (30 miles southeast via US-36 and I-225). Fast Passport Center's courier service means Louisville residents never need to make the drive." },
    { q: "Can you help Louisville tech professionals with business travel passports?", a: "Absolutely. Fast Passport Center specializes in helping Louisville's tech corridor professionals with international business travel. We understand corporate timelines and can coordinate expedited passport services to match your meeting schedules." },
    { q: "Do you serve Superior and the surrounding communities?", a: "Yes. Fast Passport Center serves all Boulder County communities including Louisville, Superior, Lafayette, Erie, Broomfield, Boulder, Longmont, Gunbarrel, and Niwot. Our service works identically across the entire area." },
    { q: "How much does an expedited passport cost in Louisville, CO?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Where can I get passport photos in Louisville?", a: "Walgreens at 400 W South Boulder Rd in Louisville offers passport photo services. Additional options include the UPS Store in Lafayette (555 W South Boulder Rd), Walgreens in Boulder (2998 Baseline Rd), and CVS in Boulder (1840 Folsom St). Photos must be 2×2 inches on a white background." },
    { q: "What's the closest major airport for international flights from Louisville, CO?", a: "Denver International Airport (DIA) is the primary international airport for Louisville travelers — approximately 40 miles southeast via US-36 and E-470. DIA offers nonstop flights to Europe, Asia, Mexico, Canada, and domestic destinations. Allow 45–55 minutes for the drive." },
    { q: "Can you process passports for the whole family?", a: "Yes. Fast Passport Center offers family passport bundles for Louisville families. We can process multiple applications simultaneously — renewals for adults, first-time passports for kids, and everything in between. All coordinated to match your family travel timeline." },
  ],
  photoLocations: [
    { name: "Walgreens — Louisville", address: "400 W South Boulder Rd, Louisville, CO 80027", hours: "Mon–Sun: 7AM–11PM" },
    { name: "UPS Store — Lafayette", address: "555 W South Boulder Rd, Lafayette, CO 80026", hours: "Mon–Fri: 8AM–6PM, Sat: 9AM–3PM" },
    { name: "Walgreens — Boulder (Baseline)", address: "2998 Baseline Rd, Boulder, CO 80303", hours: "Mon–Sun: 7AM–11PM" },
    { name: "CVS Pharmacy — Boulder", address: "1840 Folsom St, Boulder, CO 80302", hours: "Mon–Sun: 8AM–9PM" },
  ],
  dmvLocations: [
    { name: "DMV — Boulder (Boulder County)", address: "2850 Iris Ave, Boulder, CO 80304", hours: "Mon–Fri: 8AM–5PM", note: "Full-service DMV for Boulder County residents. REAL ID and driver's license renewals. Most convenient for Louisville residents.", featured: true },
    { name: "DMV — Broomfield (Broomfield County)", address: "1 Descombes Dr, Broomfield, CO 80020", hours: "Mon–Fri: 8AM–5PM", note: "Alternative DMV for Louisville residents closer to Broomfield. REAL ID processing available.", featured: false },
  ],
  airports: [
    {
      code: "DEN",
      name: "Denver International Airport",
      distance: "40 miles southeast of Louisville via US-36 and E-470",
      address: "8500 Peña Blvd, Denver, CO 80249",
      note: "Colorado's primary international airport with nonstop flights to Europe, Asia, Mexico, Canada, and domestic destinations. Approximately 45–55 minutes from Louisville.",
      flightUrl: "https://www.flydenver.com/",
      flightLabel: "DEN Flight Info",
      featured: true,
    },
    {
      code: "BDU",
      name: "Boulder Municipal Airport",
      distance: "10 miles west of Louisville via Arapahoe Road",
      address: "3327 Airport Rd, Boulder, CO 80301",
      note: "General aviation airport serving Boulder and the surrounding area. No commercial flights. Convenient for private aviation travelers.",
      flightUrl: "https://bouldercolorado.gov/",
      flightLabel: "BDU Info",
      featured: false,
    },
  ],
};